<!--
公共控制按键

使用说明：

<TopCtrl/>

-->

<template>
	<div class="top-ctrl-wrap" v-if="show">
		<Icon class="icon" :img="require('../../assets/top_icon.svg')" @click.native="goTop('clear')" />
		<Icon class="icon" :img="require('../../assets/back_icon.svg')" @click.native="goBack" />
		<Icon class="icon" :img="require('../../assets/home_icon.svg')" @click.native="goHome" />
	</div>
</template>

<script>
import store from '../../api/store';
export default {
	props: [],
	data() {
		return {
			show: false,
            oldSpeed: -100000
		};
	},
	methods: {
		goBack() {
			history.back();
		},
		goHome() {
			this.$routerReplace(this, '/pages/homepage/Index');
		},
		goTop(type) {
            // 重置oldspeed
            if(type === 'clear') this.resetOldSpeed();
            // 获取scrollTop和speed
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop === 0) return
            let ispeed = Math.floor(-scrollTop / 6);
            // 最低速度 5
            if(ispeed > -5) ispeed = -5;
            // 设置scrollTop
            document.documentElement.scrollTop = document.body.scrollTop = scrollTop + ispeed;
            // 滚动期间上划了屏幕
            if(this.oldSpeed > ispeed) return this.resetOldSpeed();
            // 上次算出来的ispeed
            this.oldSpeed = ispeed;
            // 递归调用
            if (scrollTop > 0) window.requestAniFrame(this.goTop);
        },
        resetOldSpeed() {
            this.oldSpeed = -100000
        },
	},
	mounted() {
		if (store.loginedUser.config.showNavButton) {
			this.show = true;
		}
	}
};
</script>

<style lang="less" scoped>
@w: 12vw;

.top-ctrl-wrap {
	position: fixed;
	z-index: 999;
	bottom: 15vw;
	right: 3vw;
	width: @w;
	opacity: 0.8;
}

.icon {
	display: inline-block;
	width: @w;
	height: @w;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopCtrl.vue